import React from "react";
import type { VoidFunctionComponent } from "react";
import s from "./SongDetailsLessonNonPlayActionMember.module.scss";
import Button from "../../../../../../components/common/Button";
import navigation from "../../../../../../services/navigation/navigation";

export interface ISongDetailsLessonNonPlayActionMemberProps {
  lessonId: number | string;
}

export const SongDetailsLessonNonPlayActionMember: VoidFunctionComponent<
  ISongDetailsLessonNonPlayActionMemberProps
> = ({ lessonId }) => {
  return (
    <div className={s.container}>
      <div className={s.songPrompt}>
        <Button
          buttonType={"secondary"}
          text={"Get This Song"}
          additionalClassName={s.songAction}
          onClick={() =>
            navigation.goToExternalPlaygroundSongStoreLesson(lessonId)
          }
        />
        <div className={s.details}>
          Use song credits or <br />
          purchase on our website
        </div>
      </div>
      <div className={s.membershipPrompt}>
        <button
          className={s.membershipAction}
          onClick={() =>
            navigation.goToExternalPlaygroundStoreMembershipPlans()
          }
        >
          Get unlimited songs for only $3.33/month
        </button>
      </div>
    </div>
  );
};
